import React, { Component } from 'react';
import {
 Route, Switch, NavLink, Redirect,
} from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import get from 'lodash/get';

import Text from 'ui/Text';
import PageTitle from 'shared/PageTitle';
import QuestionnaireLayout from 'components/BaseQuestionnaire/QuestionnaireLayout';
import PageNotFound from 'shared/PageNotFound';
import twitterIcon from 'assets/twitter-logo.png';
import linkedInIcon from 'assets/linkedin-logo.png';
import { LayoutSubject } from 'shared/LayoutSubject';
import { QuestionnaireSubject } from 'shared/QuestionnaireSubject';
import Connectivity from 'shared/Connectivity';
import Auth from 'shared/Auth';
import { CDRComponentMap } from '../CDRSections/CDRComponentMap';
import { PREVIOUS_STAGE_KEY } from 'utils/app-constants';
import localStorage from 'utils/localStorage';

class ApplicationLayout extends Component {
  constructor(){
    super();

    this.state = {
      sectionQuestionnaire: localStorage.getList(get(Auth.getUser(), 'current_stage_id')),
      surveyMode: Auth.isSurveyMode()
    }

    this.questionnaireListener = null;
  }

  componentDidMount(){
    this.questionnaireListener = QuestionnaireSubject.subscribe(res => {
      this.setState({ sectionQuestionnaire: []});
    });
  }

  goToAHomePage = (activeRoute) => {
    LayoutSubject.next({ activeRoute, showHome: true });
  };

  render() {    
    if (!this.state.sectionQuestionnaire) {
      Auth.logout();
    }
    
    const langMap = {
      en_US: 'title',
      fr_FR: 'title_fr',
    };
    
    const currentLanguage = get(Auth.getLanguage(), 'lang');

    const titleKey = get(langMap, currentLanguage);

    let sections;

    sections = this.state.sectionQuestionnaire.map((section, index) => (
      <li key={index} className="navigation-item">
        <NavLink to={`/section/${get(section, 'id', '')}`} className="navigation-item__link">
          <Text type="small" modifiers="pure-white">
            {get(section, titleKey, '')}
          </Text>
        </NavLink>
      </li>
    ));
    
    if (!this.state.surveyMode) {
      sections = CDRComponentMap.map((cdrSection, index) => {
        if (index === 0) {
          return (
            <li key={index} className="navigation-item">
              <Text type="small" modifiers={`pure-white no-child-padding navigation-item__link ${get(cdrSection, 'label') ? 'label' : ''}`}>
                <FormattedMessage
                  id={`Questionnaire.CDR.SubMenuItem.${get(cdrSection, 'transaltionRef')}`}
                  defaultMessage={get(cdrSection, 'name')}
                />
              </Text>
            </li>
          )
        }

        if (index === (CDRComponentMap.length - 1)) {
          return (
            <li key={index} className="navigation-item">
              <NavLink to={`/section/${localStorage.getItem(PREVIOUS_STAGE_KEY)}`} className="navigation-item__link">
                <Text type="small" modifiers="pure-white no-child-padding">
                  <FormattedMessage
                    id={`Questionnaire.CDR.SubMenuItem.${get(cdrSection, 'transaltionRef')}`}
                    defaultMessage={get(cdrSection, 'name')}
                  />
                </Text>
              </NavLink>
            </li>
          )
        }

        return (
          <li key={index} className="navigation-item">
            <NavLink to={`/section/${get(cdrSection, 'route')}`} className="navigation-item__link">
              <Text type="small" modifiers="pure-white no-child-padding">
                <FormattedMessage
                  id={`Questionnaire.CDR.SubMenuItem.${get(cdrSection, 'transaltionRef')}`}
                  defaultMessage={get(cdrSection, 'name')}
                />
              </Text>
            </NavLink>
          </li>
        )         
      });
    }

    if (this.state.surveyMode) {
      let firstItem = (
        <li key="first_item" className="navigation-item">
          <NavLink to="/section/5b7a91a6ff26" className="navigation-item__link">
            <Text type="small" modifiers="pure-white no-child-padding">
              <FormattedMessage
                id="Questionnaire.BeforeYouStart"
                defaultMessage="Before You Start"
              />
            </Text>
          </NavLink>
        </li>
      );
      
      sections.splice(0, 0, firstItem);
    }

     (sections);

    return (
      <div className="App">
        <PageTitle title="Landing Page" />
        <Connectivity />
        <section className="row no-margin dashboard-content">
          <aside className="col-3 bg-primary-blue sidebar">
            <ul className="navigation-list">{sections}</ul>
          </aside>
          <div className="col-9 bg-almost-white question-content">
            <header className="top-bar">
              <div className="icon-links text-right">
                <a
                  href="https://twitter.com/EPIC_Africa_"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={twitterIcon} className="icon" alt="Twitter Account" />
                </a>
                <a
                  href="https://www.linkedin.com/company/epic-africa-llc"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img src={linkedInIcon} className="icon" alt="Linked In Account" />
                </a>
              </div>
              <ul className="top-bar-navigation flex justify-content-end">
                <li className="top-bar-navigation-item">
                  <a
                    onClick={() => this.goToAHomePage('/#shortlisted-csos')}
                    className="top-bar-navigation-item__link"
                  >
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="ShortlistedCSOs" defaultMessage="Shortlisted CSOs" />
                    </Text>
                  </a>
                </li>
                <li className="top-bar-navigation-item">
                  <a
                    onClick={() => this.goToAHomePage('/search-csos')}
                    className="top-bar-navigation-item__link"
                  >
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="SearchCSOs" defaultMessage="Search CSOs"/>
                    </Text>
                  </a>
                </li>
                <li className="top-bar-navigation-item">
                  <a
                    onClick={() => this.goToAHomePage('/#about')}
                    className="top-bar-navigation-item__link"
                  >
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="AboutAwards" defaultMessage="About Awards" />
                    </Text>
                  </a>
                </li>
                <li className="top-bar-navigation-item">
                  <a
                    onClick={() => this.goToAHomePage('/#partners')}
                    className="top-bar-navigation-item__link"
                  >
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="Partners" defaultMessage="Partners" />
                    </Text>
                  </a>
                </li>
                <li className="top-bar-navigation-item">
                  <a
                    className="top-bar-navigation-item__link"
                    onClick={() => this.goToAHomePage('/faqs')}
                  >
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="Header.FAQ" defaultMessage="FAQ" />
                    </Text>
                  </a>
                </li>
                <li className="top-bar-navigation-item">
                  <a className="top-bar-navigation-item__link" onClick={() => Auth.logout()}>
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="Logout" defaultMessage="Logout" />
                    </Text>
                  </a>
                </li>
              </ul>
            </header>
            <Switch>
              <Route exact path="/section/:id" component={QuestionnaireLayout} />
              <Redirect from="/" to="/section/5b7a91a6ff26" />
              <Route component={PageNotFound} />
            </Switch>
          </div>
        </section>
      </div>
    );
  }
}

export default ApplicationLayout;



// WEBPACK FOOTER //
// ./src/components/Layout/ApplicationLayout.js